module.exports = __webpack_public_path__ + "static/img/favicon.ded9cd00.png";